// shared-lib/group-customization/anchorPose.js
//
// Anchor-local pose helpers shared by every build-time link emitter
// (emitVanityLinks, emitKitchenSinkLinks). Extracted from emitVanityLinks —
// neither helper is vanity-specific, and a second emitter copying them is
// exactly how the sink/countertop lookups drifted apart in the first place.

const { worldToLocal } = require('./transforms');

/**
 * Build a {id, type, dx, dy, dz, rotYRel} pose for `obj` in `anchor`'s local
 * frame. The anchor itself yields the zero pose, which is what
 * `computeRpOffset` needs when a link sources from the anchor.
 */
function buildAnchorLocal(obj, anchor) {
  if (!obj?.id || !obj?.center || !anchor) return null;
  const local = worldToLocal(obj.center, anchor);
  const anchorRotY = anchor.rotation?.y || 0;
  return {
    id: obj.id,
    type: obj.type || null,
    dx: local.dx,
    dy: local.dy,
    dz: local.dz,
    rotYRel: (obj.rotation?.y || 0) - anchorRotY,
  };
}

/** Pick the candidate whose anchor-local dx is closest to `target.dx`. */
function nearestByDx(target, candidates) {
  if (!target || !candidates || candidates.length === 0) return null;
  let best = null;
  let bestD = Infinity;
  for (const c of candidates) {
    if (!c) continue;
    const d = Math.abs((c.dx || 0) - (target.dx || 0));
    if (d < bestD) {
      bestD = d;
      best = c;
    }
  }
  return best;
}

module.exports = { buildAnchorLocal, nearestByDx };
